module.exports = __webpack_public_path__ + "static/media/ag-courtney-cover.226453a6.jpg";